import { Flex } from '@ui-library/misc';
import React, { useState } from 'react';
import queryString, { ParsedQuery } from 'query-string';
import { Label } from '@ui-library/typography';
import SetupAccount from '@auth/setupAccount/setupAccount';
import { useHistory, useLocation } from 'react-router-dom';
import Svg from '@svg/index';
import { ReactComponent as ArrowRight } from '@svg/long_right.svg';
import SetupAccountContainer from '@auth/common/container';
import VerifyEmail from './components/verifyEmail';
import Button from '@ui-library/button';
import theme from '@css/theme';
import classes from './signup.module.scss';
import Promotion from './components/promotion';
import Footer from './components/footer';
import SocialSignup from './components/socialSignup';
import SignupWithEmail from './components/signupWithEmail';
import { FREETRIAL, OPENSOURCE } from '../common/constants';
import { Row, Col } from 'antd';
import { getParsedValue } from '@components/common/util/util';
import { getPromotionText, UTM } from '@auth/common/util';
import { Path } from '@components/routes';

const separator = (
  <Flex flexDirection="row" alignItemsCenter className="full-width">
    <span className={`${classes.lineBreak} m-r-sm`} />
    <Label fontWeight={700} fontSize="11px" lineHeight="22px" color={theme.color.neutral2}>
      OR
    </Label>
    <span className={`${classes.lineBreak} m-l-sm`} />
  </Flex>
);

const logo = (
  <Flex flexDirection="column" className={classes.logo}>
    <Svg name="full-logo_02" />
  </Flex>
);

export default () => {
  const location = useLocation();
  const history = useHistory();
  const parsed = queryString.parse(location.search);
  const [email, setEmail] = useState<string>('');

  const initialType = (
    getParsedValue(parsed, 'type') === OPENSOURCE ? OPENSOURCE : FREETRIAL
  ) as UTM;

  const [renderEmailSent, setRenderEmailSent] = useState(false);
  const [type, setType] = useState(initialType);

  const getToken = () => {
    const values: ParsedQuery = queryString.parse(location.search);
    return getParsedValue(values, 'token');
  };

  const onEmailSent = () => {
    setRenderEmailSent(true);
  };

  const switchType = () => {
    const newType = type === OPENSOURCE ? FREETRIAL : OPENSOURCE;
    const addParam = newType === OPENSOURCE ? '?type=opensource' : '';
    history.replace(`${Path.SIGNUP}${addParam}`);
    setType(newType);
  };

  const token = getToken();

  if (token.length > 1) {
    return (
      <SetupAccountContainer showLogo>
        <SetupAccount token={token} />
      </SetupAccountContainer>
    );
  }

  const promotionText = getPromotionText(type);

  if (renderEmailSent) {
    return <VerifyEmail email={email} type={type} />;
  }

  return (
    <Row>
      <Col xs={{ span: 24 }} lg={{ span: 12 }}>
        <Flex flexDirection="column" className={classes.bg}>
          {logo}
          <Flex flexDirection="column" alignItemsCenter className={classes.signup}>
            <Flex flexDirection="column" alignItemsCenter>
              <SignupWithEmail
                type={type}
                onEmailSent={onEmailSent}
                email={email}
                updateEmail={setEmail}
              />
              {separator}
              <SocialSignup type={type} />
              <Footer type={type} />
              <Button secondary onClick={switchType} className={classes.button}>
                <Flex flexDirection="row" alignItemsCenter justifyContentCenter className="m-h-sm">
                  {promotionText}
                  <ArrowRight className="m-l-sm" />
                </Flex>
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </Col>
      <Col xs={{ span: 24 }} lg={{ span: 12 }}>
        <Promotion />
      </Col>
    </Row>
  );
};
